import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-slate-500 tw-text-sm" }, "months", -1)
const _hoisted_2 = { class: "tw-text-slate-500 tw-text-sm" }

import { computed, ref } from "vue"  
  import { QSelect } from "quasar"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TermSelect',
  props: {
    modelValue: {
      type: Number as () => number | null,
      default: 2,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<number>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return 0
      }
    },
    set(value: number) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const termSelectRef = ref<QSelect | null>(null);
  function validate(){
    return termSelectRef.value!.validate();
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QSelect), {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    modelModifiers: { number: true },
    options: [24, 36, 37, 48, 49, 60],
    rules: [val => !!val || 'Required'],
    "label-color": "tw-text-slate-500",
    class: "tw-text-slate-500 tw-shadow-sm",
    "input-class": "tw-text-slate-500",
    "popup-content-class": "tw-text-sm tw-text-slate-500",
    outlined: "",
    dense: "",
    "hide-dropdown-icon": "",
    ref_key: "termSelectRef",
    ref: termSelectRef,
    required: __props.required,
    "data-clarity-unmask": "true"
  }, {
    append: _withCtx(() => [
      _hoisted_1
    ]),
    selected: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(value.value), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "rules", "required"]))
}
}

})